// The current implementation supports only one pinned column on the left side
// and constantly pinned last column on the right side

export const isStickyLeft = (index: number, isFirstColumnPinned: boolean) =>
  index === 0 && isFirstColumnPinned;

export const isStickyRight = (index: number, columnsLength: number) => index === columnsLength - 1;

// extract the value of generic ID field from item
export const getItemId = <T extends Record<string, unknown>>(item: T, itemIdKey = "id"): string => {
  const value = item[itemIdKey];
  if (typeof value === "string") {
    return value;
  }

  throw new Error(`TableSimple: Unable to extract ID from item using key "${itemIdKey}"`);
};
